// @ts-nocheck
import { useDropzone } from "react-dropzone";

import Box from "@mui/material/Box";

import { varAlpha } from "@onair/config-mui/styles";

import { Iconify } from "../iconify";

import type { UploadProps } from "./types";

// ----------------------------------------------------------------------

export function UploadBox({
  hiddenBorder,
  placeholder,
  error,
  disabled,
  sx,
  ...other
}: UploadProps) {
  const { getRootProps, getInputProps, isDragActive, isDragReject } =
    useDropzone({
      disabled,
      ...other,
    });

  const hasError = isDragReject || error;

  return (
    <Box
      {...getRootProps()}
      sx={{
        width: hiddenBorder ? "unset" : 64,
        height: hiddenBorder ? "unset" : 64,
        flexShrink: 0,
        display: "flex",
        borderRadius: 1,
        cursor: "pointer",
        alignItems: "center",
        color: hiddenBorder ? "unset" : "text.disabled",
        justifyContent: "center",
        bgcolor: hiddenBorder
          ? "unset"
          : (theme) => varAlpha(theme.vars.palette.grey["500Channel"], 0.08),
        border: hiddenBorder
          ? "unset"
          : (theme) =>
              `dashed 1px ${varAlpha(theme.vars.palette.grey["500Channel"], 0.16)}`,
        ...(isDragActive && { opacity: 0.72 }),
        ...(disabled && { opacity: 0.48, pointerEvents: "none" }),
        ...(hasError && {
          color: "error.main",
          borderColor: "error.main",
          bgcolor: (theme) =>
            varAlpha(theme.vars.palette.error.mainChannel, 0.08),
        }),
        "&:hover": { opacity: 0.72 },
        ...sx,
      }}
    >
      <input {...getInputProps()} />

      {placeholder || <Iconify icon="eva:cloud-upload-fill" width={28} />}
    </Box>
  );
}
